export const GET_INTEGRATOR_SETUP_START = "@integratorSetup/GET_INTEGRATOR_SETUP_START";
export const GET_INTEGRATOR_SETUP_SUCCESS = "@integratorSetup/GET_INTEGRATOR_SETUP_SUCCESS";
export const GET_INTEGRATOR_SETUP_FAIL = "@integratorSetup/GET_INTEGRATOR_SETUP_FAIL";
export const GET_LANGUAGES_SETUP_START = "@integratorSetup/GET_LANGUAGES_SETUP_START";
export const GET_LANGUAGES_SETUP_SUCCESS = "@integratorSetup/GET_LANGUAGES_SETUP_SUCCESS";
export const GET_LANGUAGES_SETUP_FAIL = "@integratorSetup/GET_LANGUAGES_SETUP_FAIL";
export const GET_CURRENCIES_SETUP_START = "@integratorSetup/GET_CURRENCIES_SETUP_START";
export const GET_CURRENCIES_SETUP_SUCCESS = "@integratorSetup/GET_CURRENCIES_SETUP_SUCCESS";
export const GET_CURRENCIES_SETUP_FAIL = "@integratorSetup/GET_CURRENCIES_SETUP_FAIL";
export const GET_COUNTRIES_SETUP_START = "@integratorSetup/GET_COUNTRIES_SETUP_START";
export const GET_COUNTRIES_SETUP_SUCCESS = "@integratorSetup/GET_COUNTRIES_SETUP_SUCCESS";
export const GET_COUNTRIES_SETUP_FAIL = "@integratorSetup/GET_COUNTRIES_SETUP_FAIL";
export const RESET_STORE = "@integratorSetup/RESET_STORE";
